var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 475.45,
    height: 356.543,
    viewBox: "0 0 475.45 356.543",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0f4fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00baef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.06,
    x2: 1,
    y2: 0.966,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#f9f9ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebebeb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00baef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07c87a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7e45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#fe7a4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#f85876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f44293"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.5,
    y1: 18.217,
    x2: 0.5,
    y2: 15.965,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7e45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.198,
    stopColor: "#fe7a4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#fc6d5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#f85876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f44293"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    y1: 17.186,
    y2: 18.209,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b7ce3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00baef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8338ec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.38,
    y1: 0.235,
    x2: 0.585,
    y2: 0.915,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe552"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffae39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7b97e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b1ae2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "analytics",
    transform: "translate(-177.64 -1373.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_6",
    "data-name": "Union 6",
    d: "M0,69.759A23.4,23.4,0,0,1,14.034,48.2c6.532-4.975,4.08-13.418,4.08-17.9C18.114,12.809,31.226,0,48.2,0,66.364.035,67.092,11.13,78.348,11.17q.123.173.237.351.169-.287.346-.554C85.2,10.118,93.113,1.55,103.684,1.55a30.9,30.9,0,0,1,31.7,30.742,30.522,30.522,0,0,1-30.429,30.614c-4.361,0-11.418-.272-17.185,3.781-4.925,7.119-14.55,13.054-24.35,13.054-5.686,0-15.384-2.493-20.622,1.743A22.858,22.858,0,0,1,22.943,93.147,23.169,23.169,0,0,1,0,69.759Z",
    transform: "translate(558.086 1373.457) rotate(60)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons8-imac",
    transform: "translate(240 1438.109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M134.015,79.088H19.215c24.6,0,24.6-45.088,24.6-45.088h65.6S109.415,79.088,134.015,79.088Z",
    transform: "translate(87.385 195.6)",
    fill: "#c3d1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M315.6,6H20.4A16.448,16.448,0,0,0,4,22.4V202.8H332V22.4A16.448,16.448,0,0,0,315.6,6Z",
    transform: "translate(-4 -6)",
    fill: "#455a64",
    opacity: 0.679
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M6,8H319.37V186.962H6Z",
    transform: "translate(1.315 1.429)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M4,30H332V46.4a16.448,16.448,0,0,1-16.4,16.4H20.4A16.448,16.448,0,0,1,4,46.4Zm229.6,77.527H102.4v7.455H233.6Z",
    transform: "translate(-4 166.8)",
    fill: "#e8ebed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M31.2,31a8.2,8.2,0,1,0,8.2,8.2A8.2,8.2,0,0,0,31.2,31Z",
    transform: "translate(132.8 174)",
    fill: "#37474f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "analytics_icon",
    "data-name": "analytics icon",
    transform: "translate(-622.499 -118.319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_analytics_1808530_000000",
    transform: "translate(1094.789 1697.47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M13.421,47.148A11.919,11.919,0,0,0,1.5,59.069V95.293a11.921,11.921,0,0,0,23.842,0V59.069A11.919,11.919,0,0,0,13.421,47.148Z",
    transform: "translate(-1.5 13.635)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M96.421,36.773A11.919,11.919,0,0,0,84.5,48.694v53.892a11.921,11.921,0,0,0,23.842,0V48.694A11.918,11.918,0,0,0,96.421,36.773Z",
    transform: "translate(72.457 6.341)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M75.671,17.582c-6.586,0-11.921,5.839-11.921,13.047v94.754c0,7.208,5.335,13.047,11.921,13.047s11.921-5.839,11.921-13.047V30.629C87.592,23.421,82.257,17.582,75.671,17.582Z",
    transform: "translate(53.968 -17.582)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M54.921,23.547C48.335,23.547,43,29.437,43,36.709v84.367c0,7.271,5.335,13.161,11.921,13.161s11.921-5.89,11.921-13.161V36.709C66.842,29.437,61.507,23.547,54.921,23.547Z",
    transform: "translate(35.479 -13.388)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M34.171,54.93A11.918,11.918,0,0,0,22.25,66.851v22.97a11.921,11.921,0,1,0,23.842,0V66.851A11.919,11.919,0,0,0,34.171,54.93Z",
    transform: "translate(16.989 19.106)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "download_4_",
    "data-name": "download(4)",
    transform: "translate(177.716 1499.217) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M65.26,64.876h54.031a2.118,2.118,0,0,1,2.179,2.4A61.012,61.012,0,1,1,54.149-.049a2.118,2.118,0,0,1,2.4,2.179V56.161A8.74,8.74,0,0,0,65.26,64.876Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M235.249,53.764a2.118,2.118,0,0,1-2.179,2.4H183.179a4.137,4.137,0,0,1-4.139-4.139V2.13a2.118,2.118,0,0,1,2.4-2.179,43.625,43.625,0,0,1,5.229.871c.654.218,1.525.218,2.179.436l4.575,1.307c.654.218,1.089.436,1.743.654a59.836,59.836,0,0,1,18.519,10.458,19.64,19.64,0,0,1,2.179,1.961A37.134,37.134,0,0,1,220,19.777c.654.654,1.307,1.525,1.961,2.179a57.45,57.45,0,0,1,10.458,18.519c.218.654.436,1.089.654,1.743l1.307,4.575c.218.654.218,1.307.436,2.179A43.318,43.318,0,0,0,235.249,53.764Z",
    transform: "translate(-113.78 0)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M235.249,53.764a2.118,2.118,0,0,1-2.179,2.4H183.179a4.137,4.137,0,0,1-4.139-4.139V2.13a2.118,2.118,0,0,1,2.4-2.179,43.625,43.625,0,0,1,5.229.871c.654.218,1.525.218,2.179.436l4.575,1.307c.654.218,1.089.436,1.743.654a59.836,59.836,0,0,1,18.519,10.458,19.64,19.64,0,0,1,2.179,1.961A37.134,37.134,0,0,1,220,19.777c.654.654,1.307,1.525,1.961,2.179a57.45,57.45,0,0,1,10.458,18.519c.218.654.436,1.089.654,1.743l1.307,4.575c.218.654.218,1.307.436,2.179A43.318,43.318,0,0,0,235.249,53.764Z",
    transform: "translate(-113.78 0)",
    fill: "url(#linear-gradient-10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-csv",
    transform: "translate(215 1601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M104,129H8V3H74l30,30Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M57.5,33H29V4.5Z",
    transform: "translate(42 3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M33.907,43.235q-.225,5.107-2.871,7.731t-7.464,2.625q-5.062,0-7.761-3.33t-2.7-9.507V35.729q0-6.151,2.79-9.486a9.561,9.561,0,0,1,7.752-3.33q4.878,0,7.413,2.727t2.88,7.833H27.9q-.081-3.159-.975-4.359a3.848,3.848,0,0,0-3.27-1.2,3.665,3.665,0,0,0-3.426,1.689,11.833,11.833,0,0,0-1.065,5.568v5.64q0,4.45,1,6.111a3.66,3.66,0,0,0,3.414,1.662,3.954,3.954,0,0,0,3.282-1.158,7.644,7.644,0,0,0,1.026-4.194ZM50.23,45.347A3.743,3.743,0,0,0,49.3,42.59a10.722,10.722,0,0,0-3.4-1.938,15.767,15.767,0,0,1-6.459-3.99,8,8,0,0,1-1.968-5.4A7.57,7.57,0,0,1,40.15,25.2a10.086,10.086,0,0,1,6.8-2.289,10.2,10.2,0,0,1,4.9,1.158,8.024,8.024,0,0,1,3.312,3.273,9.838,9.838,0,0,1,1.158,4.8H50.311a4.974,4.974,0,0,0-.891-3.189,3.137,3.137,0,0,0-2.574-1.095,3.22,3.22,0,0,0-2.46.933A3.515,3.515,0,0,0,43.5,31.3a3.094,3.094,0,0,0,.984,2.226,11.389,11.389,0,0,0,3.486,2.061,14.894,14.894,0,0,1,6.345,3.876,8.636,8.636,0,0,1,1.98,5.844,7.7,7.7,0,0,1-2.481,6.09,9.839,9.839,0,0,1-6.747,2.193A11.632,11.632,0,0,1,41.8,52.406,8.925,8.925,0,0,1,38.077,49a9.872,9.872,0,0,1-1.344-5.229h6.051a5.713,5.713,0,0,0,1,3.753,4.111,4.111,0,0,0,3.282,1.17Q50.23,48.686,50.23,45.347Zm19.791-.369,5.025-21.657h6.726L73.159,53.18H66.883L58.33,23.321h6.687Z",
    transform: "translate(10.228 39.82)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M159.573,48q-.183,0-.367,0A18.665,18.665,0,0,1,144.7,40.619L122.166,11.24a12.535,12.535,0,0,0-19.665-.382L77.862,40.57a18.325,18.325,0,0,1-14.655,6.809A18.675,18.675,0,0,1,48.728,40.2l-12.2-15.491a12.542,12.542,0,0,0-20.152.516L5.605,40.391a3.055,3.055,0,0,1-4.32.712,3.172,3.172,0,0,1-.7-4.387l10.767-15.17A18.622,18.622,0,0,1,26.169,13.6a18.415,18.415,0,0,1,15.187,7.176l12.2,15.491a12.542,12.542,0,0,0,9.724,4.822,12.921,12.921,0,0,0,9.84-4.572L97.762,6.809a18.668,18.668,0,0,1,29.287.569l22.533,29.38a12.538,12.538,0,0,0,19.666.38L188,14.523a3.065,3.065,0,0,1,4.361-.38,3.178,3.178,0,0,1,.375,4.429L173.982,41.187A18.648,18.648,0,0,1,159.573,48Z",
    transform: "translate(503.825 1568.998) rotate(180)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "download_3_",
    "data-name": "download(3)",
    transform: "translate(-1442.693 2013.583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407",
    transform: "translate(1703.203 -564.797)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_81",
    "data-name": "Ellipse 81",
    cx: 29.369,
    cy: 29.369,
    r: 29.369,
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    cx: 5.183,
    cy: 5.183,
    r: 5.183,
    transform: "translate(12.093 20.731)",
    fill: "#c60"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    cx: 5.183,
    cy: 5.183,
    r: 5.183,
    transform: "translate(38.006 20.731)",
    fill: "#c60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M46.167,83.94h0A10.365,10.365,0,0,0,56.532,94.305c5.725,0,10.365-3.455,10.365-10.365Z",
    transform: "translate(-27.164 -49.389)",
    fill: "#c60"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_427",
    "data-name": "Group 427",
    transform: "translate(-15.884 -97.884)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_90",
    "data-name": "Ellipse 90",
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    transform: "translate(220.884 1683.884)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-percentage",
    d: "M20,23.407a4.7,4.7,0,0,1,1.286-3.427,4.5,4.5,0,0,1,3.366-1.314,4.556,4.556,0,0,1,3.4,1.3,4.788,4.788,0,0,1,1.284,3.522v1.135a4.635,4.635,0,0,1-1.285,3.418,4.539,4.539,0,0,1-3.366,1.291,4.57,4.57,0,0,1-3.39-1.3A4.751,4.751,0,0,1,20,24.525Zm2.666,1.2a2.032,2.032,0,0,0,.559,1.495,1.966,1.966,0,0,0,1.468.565,1.865,1.865,0,0,0,1.441-.574,2.152,2.152,0,0,0,.533-1.533v-1.15a2.111,2.111,0,0,0-.533-1.5,2.157,2.157,0,0,0-2.917-.009,2.168,2.168,0,0,0-.55,1.575ZM8,10.741A4.7,4.7,0,0,1,9.286,7.314,4.5,4.5,0,0,1,12.652,6a4.556,4.556,0,0,1,3.4,1.3,4.788,4.788,0,0,1,1.284,3.522v1.135a4.635,4.635,0,0,1-1.285,3.418,4.539,4.539,0,0,1-3.366,1.291,4.57,4.57,0,0,1-3.39-1.3A4.751,4.751,0,0,1,8,11.859Zm2.667,1.2a2.032,2.032,0,0,0,.559,1.495A1.966,1.966,0,0,0,12.693,14a1.865,1.865,0,0,0,1.441-.574,2.152,2.152,0,0,0,.533-1.533v-1.15a2.111,2.111,0,0,0-.533-1.5,1.91,1.91,0,0,0-1.475-.573,1.924,1.924,0,0,0-1.442.563,2.168,2.168,0,0,0-.55,1.575Zm3.152,15.63L11.74,26.135,23.332,8.141l2.083,1.444Z",
    transform: "translate(220.515 1684.822)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_92",
    "data-name": "Ellipse 92",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(596 1420)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_93",
    "data-name": "Ellipse 93",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(524 1390)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.d338653295c7454b6a290a86fac897ce.svg";
export { ForwardRef as ReactComponent };